import { eventBus } from '@/main'
import Store from '@/store'

export default (_axios) => {
  _axios.interceptors.request.use(
    async function (config) {
      return config
    },
    function (error) {
      return Promise.reject(error)
    }
  )

  // Add a response interceptor
  _axios.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      console.log(error.response)
      if ([400, 401, 500, 404].includes(error.response.status)) {
        eventBus.$emit('APP_ALERT_ERROR', error.response.data)
      }
      if ([403].includes(error.response.status)) {
        alert('Ação não permitida')
      }
      if ([401].includes(error.response.status)) {
        Store.dispatch('signout')
      }
      return Promise.reject(error)
    }
  )
}
